import Reporter from './Reporter';

let reporter = null;

export function initReporterInstance(config) {
  if (!reporter) {
    reporter = new Reporter(config);
  }
  return reporter;
}

export function getReporter() {
  if (!reporter) {
    throw new Error(
      '[@shopeepay/reporter] Reporter not initialized. Call initShopeepayReporter() first.',
    );
  }
  return reporter;
}
